import { type TableColumnSort } from '@economic/taco';

export default function parseSorting(sorting: TableColumnSort[]): string | undefined {
    if (sorting.length === 0) {
        return undefined;
    }

    return sorting.map(rule => `${rule.desc ? '-' : ''}${rule.id}`).join(',');
}
